import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HttpClientModule} from '@angular/common/http';
import { ModalModule} from 'ngx-bootstrap';
import {TabsModule} from 'ngx-bootstrap/tabs';
import { ReactiveFormsModule} from '@angular/forms';
import {DataTablesModule} from 'angular-datatables';
import {SharedModule} from '../../_shared/shared.module';
import {DepartmentTreeModule} from '../../_custom/department-tree/departments.module';
import { TreeViewModule } from '@syncfusion/ej2-angular-navigations';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { Daterangepicker } from 'ng2-daterangepicker';
import { PostNegativeComponent } from './post-negative.component';
const routes: Routes = [
  {
    path: '',
    component: PostNegativeComponent,
    data: {
      title: 'Bài viết tiêu cực chưa xử lý'
    },
  }

];
@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    TabsModule,
    DataTablesModule,
    HttpClientModule,
    ModalModule.forRoot(),
    Daterangepicker,
    ReactiveFormsModule,
    DepartmentTreeModule,
    TreeViewModule,
    AngularMultiSelectModule
  ],
  declarations: [PostNegativeComponent]
})
export class PostNegativeModule { }



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/post-negative/post-negative.module.ts